<div class="auth-layout dvh-100 d-flex flex-column overflow-hidden">
  <header class="d-none d-md-flex align-items-center justify-content-end flex-shrink-0 py-3 px-4">
    <div class="flex-grow-1"></div>
    <nav class="d-flex align-items-center gap-2">
      <a class="text-primary text-decoration-none small fw-medium" routerLink="/home">Back to Home &gt;</a>
    </nav>
  </header>

  <main class="flex-grow-1 d-flex flex-column align-items-stretch justify-content-center overflow-auto min-h-0">
    <router-outlet />
  </main>
</div>
